import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: { display: 'flex', maxWidth: '550px', marginLeft: '10vw' },
}));
